import styles from "./appLayout.module.css";
import Navbar from "./navbar";
import Sidebar from "./sidebar";

const AppLayout = ({ children }) => {
  return (
    <div className={styles.applayout_container}>
      <Sidebar />
      <div className={styles.sidebar_and_content_container}>
        <Navbar />
        <div className={styles.content_container}>{children}</div>
      </div>
    </div>
  );
};

export default AppLayout;
